/* Pouring Points article template (templates/article.pouring-points.json).
   Built 2026-10-21. Loaded once, deferred, from sections/nvwa-pp-body.liquid.

   1. GA4 events, pushed to the dataLayer for GTM (GTM-TVB92WL):
        blog_cta_click     placement, cluster, destination   a[data-pp-placement]
        blog_next_click    cluster, destination              a[data-pp-next]
        blog_toc_click     cluster                           a[data-pp-toc]
        newsletter_signup  placement, cluster                form success
      GTM needs a Custom Event trigger per name to forward them to GA4.
   2. ToC: marks the section in view (aria-current) and closes the phone pill
      after a jump.
   3. Copy link button.
   4. Newsletter forms: Klaviyo client subscriptions API, inline success state.
   5. Live prices in the FAQ block. Some bodies carry their own price loader for
      <span data-nvwa-price> / data-nvwa-price-sum; it runs inline, before the FAQ
      block below the body exists, so FAQ answers mirrored from those bodies get
      the same treatment here. The written price stays if a lookup fails. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pp-root]');
  var pageCluster = root ? root.getAttribute('data-pp-cluster') : 'default';

  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name };
    for (var key in params) payload[key] = params[key];
    window.dataLayer.push(payload);
  }

  // 1. Click events
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-pp-placement], a[data-pp-next], a[data-pp-toc]');
    if (!link) return;
    var cluster = link.getAttribute('data-pp-cluster') || pageCluster;
    if (link.hasAttribute('data-pp-placement')) {
      track('blog_cta_click', { placement: link.getAttribute('data-pp-placement'), cluster: cluster, destination: link.href });
    } else if (link.hasAttribute('data-pp-next')) {
      track('blog_next_click', { cluster: cluster, destination: link.href });
    } else {
      track('blog_toc_click', { cluster: cluster });
      var pill = link.closest('details.nvwa-pp-toc-pill');
      if (pill) pill.open = false;
    }
  });

  // 2. ToC: current section
  var tocLinks = document.querySelectorAll('a[data-pp-toc]');
  if (tocLinks.length && 'IntersectionObserver' in window) {
    var targets = [];
    var seen = {};
    tocLinks.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      if (seen[id]) return;
      seen[id] = true;
      var el = document.getElementById(id);
      if (el) targets.push(el);
    });
    var setCurrent = function (id) {
      tocLinks.forEach(function (a) {
        if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setCurrent(entry.target.id);
      });
    }, { rootMargin: '0px 0px -70% 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  }

  // 3. Copy link
  document.querySelectorAll('[data-pp-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-pp-copy');
      var label = btn.textContent;
      var done = function () {
        btn.textContent = 'Link copied';
        setTimeout(function () { btn.textContent = label; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
      } else {
        window.prompt('Copy this link', url);
      }
    });
  });

  // 4. Newsletter forms
  document.querySelectorAll('form[data-pp-newsletter]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('.nvwa-pp-nl__msg');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!email || !input.checkValidity()) {
        msg.textContent = 'Please enter a valid email address.';
        input.focus();
        return;
      }
      var placement = form.getAttribute('data-placement');
      var cluster = form.getAttribute('data-cluster') || pageCluster;
      button.disabled = true;
      msg.textContent = '';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Pouring Points (' + placement + ')',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: { blog_signup_cluster: cluster, blog_signup_placement: placement }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        var done = document.createElement('p');
        done.className = 'nvwa-pp-nl__done';
        done.setAttribute('role', 'status');
        done.textContent = 'Check your inbox';
        form.replaceWith(done);
        track('newsletter_signup', { placement: placement, cluster: cluster });
      }).catch(function () {
        button.disabled = false;
        msg.textContent = 'Something went wrong. Please try again.';
      });
    });
  });

  // 5. Live prices in the FAQ block
  var faqPrices = document.querySelectorAll('.nvwa-pp-faq [data-nvwa-price], .nvwa-pp-faq [data-nvwa-price-sum]');
  if (faqPrices.length) {
    var fmt = function (cents) {
      var v = cents / 100;
      return '$' + (v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    };
    var cache = {};
    var price = function (handle) {
      if (!cache[handle]) {
        cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return null;
            var c = typeof p.price_min === 'number' ? p.price_min : p.price;
            return typeof c === 'number' ? c : null;
          })
          .catch(function () { return null; });
      }
      return cache[handle];
    };
    faqPrices.forEach(function (el) {
      if (el.hasAttribute('data-nvwa-price')) {
        price(el.getAttribute('data-nvwa-price')).then(function (c) { if (c !== null) el.textContent = fmt(c); });
      } else {
        var handles = el.getAttribute('data-nvwa-price-sum').split(',');
        Promise.all(handles.map(price)).then(function (cs) {
          if (cs.some(function (c) { return c === null; })) return;
          el.textContent = fmt(cs.reduce(function (a, b) { return a + b; }, 0));
        });
      }
    });
  }
})();
